import React from "react";
import { Box, Typography } from "@mui/material";
import Battery1BarIcon from "@mui/icons-material/Battery1Bar";
import Battery2BarIcon from "@mui/icons-material/Battery2Bar";
import Battery4BarIcon from "@mui/icons-material/Battery4Bar";
import Battery5BarIcon from "@mui/icons-material/Battery5Bar";
import BatteryFullIcon from "@mui/icons-material/BatteryFull";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";

const ENERGY_OPTIONS = [
  {
    value: 1,
    label: "Exhausted",
    icon: <Battery1BarIcon sx={{ fontSize: 36 }} />,
    color: "#cb5538",
  },
  {
    value: 2,
    label: "Tired",
    icon: <Battery2BarIcon sx={{ fontSize: 36 }} />,
    color: "#c26229",
  },
  {
    value: 3,
    label: "Okay",
    icon: <Battery4BarIcon sx={{ fontSize: 36 }} />,
    color: "#ffa600",
  },
  {
    value: 4,
    label: "Energised",
    icon: <Battery5BarIcon sx={{ fontSize: 36 }} />,
    color: "#83a32e",
  },
  {
    value: 5,
    label: "Supercharged",
    icon: <BatteryFullIcon sx={{ fontSize: 36 }} />,
    color: "#197b68",
  },
];

/**
 * Asks the user about their energy level today, with 5 card options.
 */
const EnergyStep = ({ selected, onSelect, loading }) => {
  return (
    <Box className="task-guide-step task-guide-step--energy">
      <AnimatedOrb size="medium" intensity="idle" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          And how much energy do you have right now?
        </Typography>
      </SpeechBubble>

      <Box className="task-guide-step__mood-cards">
        {ENERGY_OPTIONS.map((option) => (
          <Box
            key={option.value}
            className={`task-guide-step__mood-card ${selected === option.value ? "task-guide-step__mood-card--selected" : ""}`}
            onClick={() => onSelect(option.value)}
            sx={{
              borderColor:
                selected === option.value ? option.color : "transparent",
              "&:hover": { borderColor: option.color },
            }}
          >
            <Box sx={{ color: option.color }}>{option.icon}</Box>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, mt: 0.5, fontSize: "0.8rem" }}
            >
              {option.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default EnergyStep;
